import type { CompanyApplicationsListScope } from '@/lib/companyApplicationsList';
import type { Period } from '@/hooks/useDashboardMetrics';

export const queryKeys = {
  positions: (companyId: string) => ['positions', companyId] as const,
  applications: (companyId: string, archived = false) =>
    ['applications', companyId, archived] as const,
  applicationsList: (companyId: string, scope: CompanyApplicationsListScope) =>
    ['applications-list', companyId, scope] as const,
  applicationsArchivedCount: (companyId: string) =>
    ['applications-archived-count', companyId] as const,
  applicationsActiveCount: (companyId: string) =>
    ['applications-active-count', companyId] as const,
  applicationsFilteredCount: (companyId: string, scope: CompanyApplicationsListScope) =>
    ['applications-filtered-count', companyId, scope] as const,
  companyTeams: (companyId: string) => ['companyTeams', companyId] as const,
  postingsAll: (companyId: string) => ['postings', companyId] as const,
  position: (companyId: string, positionId: string) => ['position', companyId, positionId] as const,
  positionPostings: (companyId: string, positionId: string) =>
    ['postings', companyId, positionId] as const,
  positionApplications: (companyId: string, positionId: string, archived = false) =>
    ['applications', companyId, positionId, archived] as const,
  pipelineStatusCounts: (companyId: string, period: Period) =>
    ['dashboard-pipeline-counts', companyId, period] as const,
  /** Agency owner portfolio fan-out — keyed by sorted active client ids. */
  agencyPortfolio: (cohortKey: string) => ['agency-portfolio', cohortKey] as const,
};
